var Tree = require('./tree'),
    FRResultNode = require('./frResultNode');




var FRSearchTree = function( root ) {

    this.root = root || new FRResultNode({
        isRoot: true,
        rowLevel: 0
    });

};


FRSearchTree.prototype = Object.create( Tree.prototype );
FRSearchTree.prototype.constructor = FRSearchTree;



_.extend( FRSearchTree.prototype, {


    updateHierarchyPostModelAttributeToggle: function( rowModel, modelAttribute ) {

        var valueToSet = !rowModel.get( modelAttribute );

        /* Go Down -- Toggle All Children */
        rowModel.walkDown( function( node ) {
            node.set( modelAttribute, valueToSet );
        } );

        /* Go back up */

        /* Walk up from the parent -- here avoids issue that hits don't have a parent -- we don't perform anything on this node anyway */
        /* Except for the root! */

        var parent;

        if ( rowModel.isRoot() ) {

            parent = rowModel;

        } else {

            parent = !rowModel.getParent() ? this.getParentOfHitModel(rowModel) : rowModel.getParent();
        }


        parent.walkUp( function( node ) {

            var allChildrenAreApplied = _.map( node.getChildren(), function(c) {
                return c.get( modelAttribute );
            } ).every( function(c) {
                return c === true; }
            );

            node.set( modelAttribute, allChildrenAreApplied );

        });

    },

    updateHierarchyIncludes: function( rowModel ) {

        this.updateHierarchyPostModelAttributeToggle( rowModel, 'isApplied' );

    },

    updateHierarchyCollapsed: function( rowModel ) {

        this.updateHierarchyPostModelAttributeToggle( rowModel, 'isCollapsed' );

    },

    getNodesOfLevel: function( level ) {

        var nodes = [];


        this.walkDown( function(node) {

            if ( node.get('rowLevel') === level ) {
                nodes.push( node );
            }

        });

        return nodes;


    },


    updateStateFromHits: function() {

        /* First clear all non hit values */
        /* Stop at the leaf -- could have fn for that in lib ? ... */
        /* Alt could destroy and create from hits, as in above... */
        this.walkDown( function( node ) {

            if ( node.hasChildren() ) {
                node.resetState();
            }

        });

        // could be combined with tree creation but need to set the 'state' from the hits of the 'rows'
        // This is not the most efficient ... ( has overlap, 'parents set multiple times' ) -- really want a 'level' walkup when all are done ...
        var levelTwoNodes = this.getNodesOfLevel( 2 );

        levelTwoNodes.forEach( function(n) {

            n.walkUp( function( node ) {

                var allApplied = _.every( node.getChildren(), function(h) {
                    return h.get('isApplied');
                });

                var allCollapsed = _.every( node.getChildren(), function(h) {
                    return h.get('isCollapsed');
                });

                node.set({
                    isApplied: allApplied,
                    isCollapsed: allCollapsed
                }, { silent: true} );


            });

        });


    },



    reset: function() {

        var root = this.getRoot();

        /* I think could also just set root to null ? */
        root.resetState();

        root.removeAllChildren();

        return this;


    },

    addHitFromSearch: function() {},


    updateCurrentPageNumber: function( currentPageNumber ) {

        this.getNodesOfLevel( this.PAGE_NODE_LEVEL ).forEach( function( pageNode ) {
            pageNode.updateIsCurrentPage( currentPageNumber );
        });

    },


    collapseAllButSearch: function( search ) {

        this.walkDown( function( node ) {
            node.set('isCollapsed', true );
        });

        var nodesOfSearch = this.getRoot().filter( function(node) {
            return node.isSearchNode() && node.get('search') && node.get('search').cid === search.cid;
        });

        if ( nodesOfSearch.length > 0) {

            nodesOfSearch.forEach( function(node) {

                node.walkDown( function(node) {
                    node.set('isCollapsed', false);
                });

            }, this);

        }

        // Walk up -- quick sorta copy paste from reset from hits  ... not most efficient -- 2 for pages .. need 2 or 1?

        this.getNodesOfLevel( 2 ).forEach( function(n) {

            n.walkUp( function( node ) {

                var allCollapsed = _.every( node.getChildren(), function(h) {
                    return h.get('isCollapsed');
                });

                node.set({ isCollapsed: allCollapsed } );

            });

        });

    },

    unCollapseAll: function() {

        this.walkDown( function(node) {
            node.set({ isCollapsed: false } );
        });

    }


});



module.exports = FRSearchTree;




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/hierarchy/frResultTree.js
 ** module id = 667
 ** module chunks = 0
 **/